/* @flow */

//----------------------------------------------------------------------//
//                         Imported NPM modules                         //
//----------------------------------------------------------------------//

import * as React from 'react';
import { translate } from 'react-i18next';
import type { TranslatorProps } from 'react-i18next';

import { PureComponentWithInjectedProps } from 'utils/injectedProps';

//----------------------------------------------------------------------//
//                     Imported app modules/assets                      //
//----------------------------------------------------------------------//

import styles from './UserProfileRole.module.scss';

//----------------------------------------------------------------------//
//                       Exported React component                       //
//----------------------------------------------------------------------//

export type UserProfileRoleProps = {
  // eslint-disable-line flow-prefer-exact-object-types
  userDetails: Object,
  userTypes: number[],
  userRole: number,
};

type InjectedProps = TranslatorProps;

@translate()
export default class UserProfileRole extends PureComponentWithInjectedProps<
  UserProfileRoleProps,
  InjectedProps
> {
  render() {
    const { userDetails, userRole, userTypes, t } = this.props;

    return (
      <div className={styles['user-profile-role']}>
        <div className={styles['user-profile-heading']}>
          <h2>
            <strong>{`${userDetails.first_name} ${userDetails.last_name}`}</strong>
            <span>{t(`general:roles.${userRole}`)}</span>
          </h2>
        </div>
        <div className={styles['user-profile-content']}>
          {userTypes.map(item => {
            const selectedClass: string = item === userRole ? styles['selected-role'] : '';

            return (
              <div key={item} className={`${styles['user-role']} ${selectedClass}`}>
                <svg>
                  <use xlinkHref="#icon-profile" />
                </svg>
                <span>{t(`general:roles.${item}`)}</span>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}
